import React from "react";

import { MetaTags } from "react-meta-tags";
import {
  Breadcrumbs,
  DashBreadcrumb,
} from "../../components/Common/Breadcrumb";
//../../../components/Common/Breadcrumb
import {
    Col,
    Container,
    Row,
    FormGroup, 
    InputGroup, 
  } from "reactstrap";

import ListComponent from "./components/StoreSelection/List.component";
import QueueExportReport from "./components/QueueExportReport";
import { EXPORT_ALLOWED_USER_ROLES } from "../../constants";
const ManageQueue = () => {
  const title = "Queue List";
  const description = "Queue List";
  const users = JSON.parse(localStorage?.getItem('authUser'));
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Cancel Request</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Row>
            <Col xl={6}>
              <DashBreadcrumb title="Queue List" breadcrumbItem="Manage Cancel Request" />
            </Col>
            <Col>
              {EXPORT_ALLOWED_USER_ROLES.includes(users?.role_id) ? (
                <QueueExportReport users={users} type="cancel" exportType="Cancel requests" />
              ) : (
                ''
              )}
            </Col>
          </Row>
         <ListComponent></ListComponent>
        </Container>
      </div>
    </React.Fragment>
  );
};
export default ManageQueue;
